/**
 * @generated SignedSource<<903ea0cfe6a5a10833f008313a2923c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleCommentsTriggerArticle$data = {
  readonly commentCount: number | null;
  readonly entityId: string;
  readonly " $fragmentType": "articleCommentsTriggerArticle";
};
export type articleCommentsTriggerArticle$key = {
  readonly " $data"?: articleCommentsTriggerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleCommentsTriggerArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "0d2c35259bd15a0a2ef392f3d1edb80f";

export default node;
